<div>
  <p class="mb-8 text-xs text-gray-500">Seja bem-vindo! Preencha os campos abaixo para criar a sua
    conta</p>


  <form class="space-y-6" [formGroup]="form" (ngSubmit)="onSubmit()">

    <div class="space-y-8 text-xs">

      <div>
        <app-phone-number-field>
          <app-text-input [formGroup]="form" type="number" id="phoneNumber" [maxLength]="9" [hideCounter]="true"
                          label="Número de telefone"
                          [value]="form.value?.phoneNumber" [formError]="formErrors.get('phoneNumber')"></app-text-input>
        </app-phone-number-field>
      </div>

      <!-- firstname -->
      <div>
        <app-text-input [formGroup]="form" id="firstname" [maxLength]="25" label="Primeiro Nome"
                        [value]="form.value?.firstname" [formError]="formErrors.get('firstname')"></app-text-input>
      </div>

      <!-- lastname -->
      <div>
        <app-text-input [formGroup]="form" id="lastname" [maxLength]="25" label="Último Nome"
                        [value]="form.value?.lastname" [formError]="formErrors.get('lastname')"></app-text-input>
      </div>

      <!-- password-->
      <div>
        <app-text-input [formGroup]="form" id="password" [maxLength]="100" type="password"
                        label="Palavra-chave"
                        [hideCounter]="true"
                        [value]="form.value?.password" [formError]="formErrors.get('password')"></app-text-input>
      </div>

      <!--password repeat-->
      <div>
        <app-text-input [formGroup]="form" id="passwordRe" [maxLength]="100" type="password"
                        label="Repita a palavra-chave"
                        [hideCounter]="true"
                        [value]="form.value?.passwordRe" [formError]="formErrors.get('passwordRe')"></app-text-input>
      </div>

    </div>

    <!-- submit button -->
    <div class="mt-6">
      <!-- [disabled]="!form.valid" -->
      <app-ae-button variant="primary" label="Criar Conta" type="submit" size="sm"
                styleClass="w-full text-xs"></app-ae-button>
    </div>
  </form>

  <p class="mt-6 text-sm text-center text-gray-500">Já possui conta?
    <a routerLink="/acesso" class="text-blue-500 focus:outline-none focus:underline hover:underline">
      Clique aqui para aceder!</a></p>
</div>
